import React, { useState } from 'react'
import { Badge, Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { BsPerson, BsPersonFill } from 'react-icons/bs';

const Register = () => {
    const navigate = useNavigate();
    const [message, setMessage] = useState();
    const [user, setUser] = useState({
        firstName: '',
        lastName: '',
        username: '',
        password: '',
        email: '',
        mobileNo: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser((preValue) => ({ ...preValue, [name]: value }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <>
            <Container>
                <Row className="justify-content-center d-flex align-items-center mh-100vh">
                    <Col md={6} xl={4}>
                        <h4></h4>
                        <Card className="card-form mt-2 mb-2">
                            <Card.Body className='pt-0'>
                                <Card.Title className='fs-22 text-center'>
                                    <h4 className="lr-title">SHREE KRISHNA XEROX</h4>
                                    <BsPersonFill size={22} /> REGISTER
                                </Card.Title>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">First Name</Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="text"
                                                maxLength={20}
                                                name='firstName'
                                                value={user.firstName}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">Last Name</Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="text"
                                                maxLength={20}
                                                name='lastName'
                                                value={user.lastName}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">Username</Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="text"
                                                maxLength={20}
                                                name='username'
                                                value={user.username}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">Password</Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="password"
                                                maxLength={20}
                                                name='password'
                                                value={user.password}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">Email</Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="text"
                                                maxLength={50}
                                                name='email'
                                                value={user.email}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">Mobile No</Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="text"
                                                maxLength={10}
                                                name='mobileNo'
                                                value={user.mobileNo}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                    {message && (
                                        <Form.Group as={Row} className="mb-3">
                                            <Col sm={{ span: 9, offset: 3 }}>
                                                <Badge bg="light" text="danger">{message}</Badge>
                                            </Col>
                                        </Form.Group>
                                    )}
                                    <Form.Group as={Row}>
                                        <Col className='text-center'>
                                            <Button type="submit" className='mw-100'>
                                                <BsPerson size={24} /> Register
                                            </Button>
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Register;